import { addition, multiplication, roundNearest, reverseIntConversion } from './floatingMath';

const is = (type, support) => support.type && support.type.code === type;

const isEnseigne = (support) => is('enseigne', support);

const isPreenseigne = (support) => is('preenseigne', support);

const isPublicite = (support) => is('publicite', support);

const getSurfaceTaxable = (support) => {
    if (!support.hauteur || !support.largeur) {
        return 0;
    }
    const surfaceUnitaire = multiplication(support.hauteur, support.largeur, 2);
    const surfaceUnitaireTaxable = roundNearest(surfaceUnitaire, 1);

    return roundNearest(multiplication(surfaceUnitaireTaxable, support.faces, 2), 1);
};

const getConditionsApplicationTarifById = (tarif, id) => {
    return tarif.tarif.condition_application_tarifs.find((conditionApplication) => conditionApplication.id === id);
};

const getTarif = (tarifs, surface, type, numerique) => {
    let tarifToUse = null;
    tarifs.forEach((tarif) => {
        let isRightOne = true;
        if (!type) {
            isRightOne = false;
        }

        if (getConditionsApplicationTarifById(tarif, 1) && 'enseigne' !== type) {
            isRightOne = false;
        }

        if (getConditionsApplicationTarifById(tarif, 2) && 'publicite' !== type) {
            isRightOne = false;
        }

        if (getConditionsApplicationTarifById(tarif, 17) && 'preenseigne' !== type) {
            isRightOne = false;
        }

        if (getConditionsApplicationTarifById(tarif, 3) && !numerique) {
            isRightOne = false;
        }

        if (getConditionsApplicationTarifById(tarif, 4) && numerique) {
            isRightOne = false;
        }

        if (getConditionsApplicationTarifById(tarif, 5) && surface > 7) {
            isRightOne = false;
        }

        if (getConditionsApplicationTarifById(tarif, 6) && surface <= 7) {
            isRightOne = false;
        }

        if (getConditionsApplicationTarifById(tarif, 7) && surface > 12) {
            isRightOne = false;
        }

        if (getConditionsApplicationTarifById(tarif, 8) && surface <= 12) {
            isRightOne = false;
        }

        if (getConditionsApplicationTarifById(tarif, 9) && surface > 20) {
            isRightOne = false;
        }

        if (getConditionsApplicationTarifById(tarif, 10) && surface <= 20) {
            isRightOne = false;
        }

        if (getConditionsApplicationTarifById(tarif, 11) && surface > 50) {
            isRightOne = false;
        }

        if (getConditionsApplicationTarifById(tarif, 12) && surface <= 50) {
            isRightOne = false;
        }

        if (getConditionsApplicationTarifById(tarif, 13) && surface > 1.5) {
            isRightOne = false;
        }

        if (getConditionsApplicationTarifById(tarif, 14) && surface <= 1.5) {
            isRightOne = false;
        }

        if (getConditionsApplicationTarifById(tarif, 15) && surface > 50) {
            isRightOne = false;
        }

        if (getConditionsApplicationTarifById(tarif, 16) && surface <= 50) {
            isRightOne = false;
        }

        if (isRightOne) {
            tarifToUse = { ...tarif };
        }
    });
    if (tarifToUse) {
        return tarifToUse;
    }

    return null;
};

const getMontantTarif = (tarif) => multiplication(tarif.montant, reverseIntConversion(100 - tarif.pourcentage_refaction, 2));

const getOptionByCode = (options, code) => options.find((option) => option.option_calcul_taxe.code === code);

const getDatas = (supports, tarifs, options) => {
    const nonScelle = getOptionByCode(options, 'non_scelle').valeur;
    const nonScelleExo50 = getOptionByCode(options, 'non_scelle_exo_50').valeur;
    const preEnseigneInf1m5 = getOptionByCode(options, 'pre_enseigne_inf_1m5').valeur;

    const enseignes = [];
    let nbEnseignes = 0;
    let nbPreenseignes = 0;
    let nbPublicite = 0;

    let montantEnseignes = 0;
    let montantPreenseignes = 0;
    let montantPublicite = 0;

    let surfaceEnseignes = 0;
    let surfaceEnseignesNonScellees = 0;
    let surfacePreenseignes = 0;
    let surfacePublicites = 0;

    let nbSupports = 0;
    let surfaceSupports = 0;
    let montantSupports = 0;

    let tarif = null;
    let tarifsUsed = [];

    Object.keys(supports).forEach((id) => {
        const support = supports[id];
        const surface = getSurfaceTaxable(support);
        if (surface) {
            const type = support.type ? support.type.code : null;
            const numerique = support.numerique;
            if (isEnseigne(support)) {
                surfaceEnseignes += surface;
                if (!support.scelle) {
                    surfaceEnseignesNonScellees += surface;
                }
                nbEnseignes++;
                enseignes.push(support);
            }
            if (isPreenseigne(support)) {
                surfacePreenseignes += surface;
                nbPreenseignes++;
                tarif = getTarif(tarifs, surface, type, numerique);
                tarifsUsed.push(tarif.tarif);
                // Si l'option est cochée,
                // on ne compte que les pré-enseignes sup à 1.5m²
                if (!(preEnseigneInf1m5 && surface < 1.5)) {
                    montantPreenseignes = addition(montantPreenseignes, roundNearest(multiplication(surface, getMontantTarif(tarif)),1));
                }
            }
            if (isPublicite(support)) {
                surfacePublicites += surface;
                nbPublicite++;
                tarif = getTarif(tarifs, surface, type, numerique);
                tarifsUsed.push(tarif.tarif);
                montantPublicite = addition(montantPublicite, roundNearest(multiplication(surface, getMontantTarif(tarif)),1));
            }
        }
    });

    if (surfaceEnseignes) {
        tarif = getTarif(tarifs, surfaceEnseignes, 'enseigne', false);
        tarifsUsed.push(tarif.tarif);
        enseignes.forEach((support) => {
            const surface = getSurfaceTaxable(support);
            let tarifApplique = getMontantTarif(tarif);

            if (!support.scelle && surfaceEnseignes <= 12) {
                if (nonScelle) {
                    tarifApplique = 0;
                }
                if (nonScelleExo50) {
                    tarifApplique = tarifApplique / 2;
                }
            }

            montantEnseignes = addition(montantEnseignes, roundNearest(multiplication(surface, tarifApplique),1));
        });
    }

    nbSupports = addition(addition(nbEnseignes, nbPreenseignes), nbPublicite);
    surfaceSupports = addition(addition(surfaceEnseignes, surfacePreenseignes), surfacePublicites);
    montantSupports = addition(addition(montantEnseignes, montantPreenseignes), montantPublicite);

    return {
        enseignes: {
            nombre: nbEnseignes,
            surface: surfaceEnseignes.toFixed(2),
            montant: montantEnseignes.toFixed(2),
        },
        preenseignes: {
            nombre: nbPreenseignes,
            surface: surfacePreenseignes.toFixed(2),
            montant: montantPreenseignes.toFixed(2),
        },
        publicites: {
            nombre: nbPublicite,
            surface: surfacePublicites.toFixed(2),
            montant: montantPublicite.toFixed(2),
        },
        totaux: {
            nombre: nbSupports,
            surface: surfaceSupports.toFixed(2),
            montant: montantSupports.toFixed(2),
        },
        tarifsUsed: [...tarifsUsed],
    };
}

export default getDatas;



// WEBPACK FOOTER //
// ./src/utils/getDatas.js